import { memo } from "react";

import { BentoBoxCardPlaceholder } from "@react/sections/BentoBox/BentoBoxCard/BentoBoxCardPlaceholder.view";
import { styles } from "@react/sections/BentoBox/BentoBoxCards/BentoBoxCardsLayoutB.data";
import { type BentoBoxCardProps } from "@root/tablescape/state/bentoBox";
import { tw } from "classnames";

type Props = {
  cards: BentoBoxCardProps[];
};

const BentoBoxCardsLayoutBPlaceholderBase = ({ cards }: Props) => {
  return (
    <div className={tw(styles.base, "animate-pulse")}>
      {cards[0] && <BentoBoxCardPlaceholder {...cards[0]} />}
      <div className={styles.nestedGrid}>
        {cards[1] && <BentoBoxCardPlaceholder {...cards[1]} />}
        {cards[2] && <BentoBoxCardPlaceholder {...cards[2]} />}
        {cards[3] && <BentoBoxCardPlaceholder {...cards[3]} />}
        {cards[4] && (
          <BentoBoxCardPlaceholder
            {...cards[4]}
            className={styles.nestedCard4}
            position={5}
          />
        )}
      </div>
      {cards[4] && (
        <BentoBoxCardPlaceholder {...cards[4]} className={styles.card4} />
      )}
      {cards[5] && (
        <BentoBoxCardPlaceholder {...cards[5]} className={styles.card5} />
      )}
    </div>
  );
};

export const BentoBoxCardsLayoutBPlaceholder = memo(
  BentoBoxCardsLayoutBPlaceholderBase
);
